export default __webpack_public_path__ + "locales/zh-CN/Payments.json?hash=84c55fda311f0639b8b3a499f29d1199";